import { render, staticRenderFns } from "./MunicipalityDetails.vue?vue&type=template&id=566f2d9c&"
import script from "./MunicipalityDetails.vue?vue&type=script&lang=js&"
export * from "./MunicipalityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports